import React, { useState, useEffect } from 'react';
import { Box, Input, FormControl } from '@chakra-ui/react';

/**
 * Vehicle Autocomplete Component for Purchase Module
 * Drop-in replacement for vehicle number field
 */
export const VehicleAutocomplete = ({
  value,
  onChange,
  onSelect,
  vehicleList = [],
  error,
  placeholder = "Vehicle Number",
  width = "150px"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filteredVehicles, setFilteredVehicles] = useState([]);

  useEffect(() => {
    if (value && value.length > 0) {
      const filtered = vehicleList?.filter((v) =>
        (v.vehicleno || '')
          .toLowerCase()
          .includes((value || '').toLowerCase())
      ) || [];
      setFilteredVehicles(filtered);
      setIsOpen(filtered.length > 0);
    } else {
      setIsOpen(false);
      setFilteredVehicles([]);
    }
  }, [value, vehicleList]);

  const handleSelect = (vehicle) => {
    onSelect(vehicle.vehicleno);
    setIsOpen(false);
  };

  return (
    <FormControl>
      <Box position="relative" w={width}>
        <Input
          placeholder={placeholder}
          size="md"
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
            setIsOpen(true);
          }}
          onFocus={() => value && value.length > 0 && setIsOpen(true)}
          onBlur={() => setTimeout(() => setIsOpen(false), 200)}
          borderColor={error ? "red.500" : "gray.300"}
          border={error ? "2px solid" : "1px solid"}
        />

        {isOpen && value && value.length > 0 && (
          <Box
            position="absolute"
            top="100%"
            left={0}
            right={0}
            bg="white"
            border="1px solid #ccc"
            borderRadius="md"
            zIndex={20}
            maxH="150px"
            overflowY="auto"
            mt={1}
            shadow="md"
          >
            {filteredVehicles.length > 0 ? (
              filteredVehicles.map((v) => (
                <Box
                  key={v.id}
                  px={3}
                  py={2}
                  _hover={{ bg: "blue.50", cursor: "pointer" }}
                  onClick={() => handleSelect(v)}
                  borderBottom="1px"
                  borderColor="gray.100"
                  fontSize="sm"
                >
                  {v.vehicleno}
                </Box>
              ))
            ) : (
              <Box px={3} py={2} color="gray.500" fontSize="sm">
                No vehicles found
              </Box>
            )}
          </Box>
        )}
      </Box>
    </FormControl>
  );
};

export default VehicleAutocomplete;